import { render, staticRenderFns } from "./traceSummary.vue?vue&type=template&id=32a95017&scoped=true&"
import script from "./traceSummary.vue?vue&type=script&lang=js&"
export * from "./traceSummary.vue?vue&type=script&lang=js&"
import style0 from "./traceSummary.vue?vue&type=style&index=0&id=32a95017&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a95017",
  null
  
)

export default component.exports